<template>
    <b-nav ref="container" class="sub-menu" @scroll="onScrolled">
        <b-container>
            <slot></slot>
        </b-container>
    </b-nav>
</template>

<script>
export default {
    name: `sub-menu`,
    props: {
        id: {type: String, required: true}
    },
    activated() {
        this.updateScroll();
    },
    mounted() {
        this.updateScroll();
    },
    methods: {
        updateScroll() {
            if (this.isMobileLayout) {
                const scrollLeft = localStorage.getItem(`menu-${this.id}-scroll`);
                if (scrollLeft > 0) {
                    this.$refs.container.scroll(scrollLeft, 0);
                }
            }
        },
        onScrolled() {
            if (this.isMobileLayout) {
                localStorage.setItem(`menu-${this.id}-scroll`, this.$refs.container.scrollLeft);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.sub-menu {
    width: 100%;
    text-align: center;
    background-color: rgba(0, 0, 0, .85);
    backdrop-filter: saturate(180%) blur(20px);
    display: flex;
    height: 100px;
    max-width: 100%;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 110;

    &::-webkit-scrollbar {
        display: none;
    }
}

@media (max-width: 576px) {
    .sub-menu {
        height: 86px;

        > .container {
            padding: 0 5px;
        }
    }
}
</style>
